/* eslint-disable global-require */

import loadComponent from 'base/loadComponent';

// add js only for casino pages
if (window.IS_CASINO === true) {
    require('../../components/casino/my-account/MyTransactions/SingleCasinoTransaction');
    require('./ScrollableText');
    loadComponent('casino/Homepage/News/News', 'casino-homepage-news');
}
